import ReactDOM from 'react-dom/client'
import App from './App'
import { Provider } from 'react-redux'
import { store } from './redux/store'

import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css'
import { registerServiceWorker } from './utils/pwa'
import { PwaInstallProvider } from './context/PwaInstallContext'

registerServiceWorker()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <>
    <Provider store={store}>
      <PwaInstallProvider>
        <App />
      </PwaInstallProvider>
    </Provider>
  </>
)
